module.exports = __webpack_public_path__ + "img/experience.41dc47a5.svg";